import { render, staticRenderFns } from "./CustomReview.vue?vue&type=template&id=e04d31e6&scoped=true"
import script from "./CustomReview.vue?vue&type=script&lang=js"
export * from "./CustomReview.vue?vue&type=script&lang=js"
import style0 from "./CustomReview.vue?vue&type=style&index=0&id=e04d31e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04d31e6",
  null
  
)

export default component.exports